import React from 'react'

const dateRange = [
    [1, 2, 3, 4, 5, 6, 7],
    [8, 9, 10, 11, 12, 13, 14],
    [15, 16, 17, 18, 19, 20, 21],
    [22, 23, 24, 25, 26, 27, 28],
    [29, 30, 31, null, null, null, null],
]

type OptionalNumber = number | null

interface AbsoluteCalendarProps {
    targetDate: OptionalNumber
    date: number
    setDate: React.Dispatch<React.SetStateAction<number>>
}

const validDateRange = Array.from(new Array(31)).map((it, idx) => idx + 1)

function CalendarDateItem({ item, targetDate, candidateDates, date, setDate }) {
    if (item === null) {
        return <div className="h-10 w-10" />
    }
    if (date == item) {
        return (
            <div
                className="h-10 w-10 flex items-center justify-center bg-primary-blue text-white rounded-3xl font-normal"
                onClick={() => setDate(item)}
            >
                {item}
            </div>
        )
    }
    if (candidateDates[item]) {
        if (item == targetDate || (targetDate === 0 && item === 31)) {
            return (
                <div
                    className="h-10 w-10 flex items-center justify-center bg-bright-light-green border-2 border-dashed border-light-green rounded-3xl font-normal"
                    onClick={() => setDate(item)}
                >
                    {item}
                </div>
            )
        }
        return (
            <div
                className="h-10 w-10 flex items-center justify-center border-2 border-dashed border-light-green rounded-3xl font-normal"
                onClick={() => setDate(item)}
            >
                {item}
            </div>
        )
    }
    return (
        <div className="h-10 w-10 flex items-center justify-center" onClick={() => setDate(item)}>
            {item}
        </div>
    )
}

export function AbsoluteDateCalendar({ targetDate, date, setDate }: AbsoluteCalendarProps) {
    // If targetDate == 0 -> End of Month
    const dueDayStr = targetDate === 0 ? 'วันสิ้นเดือน' : `ทุกวันที่ ${targetDate}`
    const validTargetDate = targetDate === 0 ? 31 : targetDate !== null ? targetDate : 31
    const intermediateDateRange = validDateRange.concat(validDateRange)
    const candidateDates =
        targetDate !== null
            ? Array.from(new Array(7)).reduce((acc, it, idx) => {
                  acc[intermediateDateRange[-idx + 31 + validTargetDate - 1]] = 1
                  return acc
              }, {})
            : {}

    return (
        <div className="font-light">
            {targetDate !== null && (
                <div className="pt-4 pb-2 text-md text-primary-blue">
                    <span className="text-bold">วันครบกำหนดชำระของคุณ คือ </span> {dueDayStr}
                </div>
            )}
            <div className="pb-4 text-md">เลือกวันที่ต้องการเตือน</div>
            <div className="flex flex-col h-30 text-xl gap-1">
                {dateRange.map((items, idx) => (
                    <div className="flex flex-row gap-1" key={idx}>
                        {items.map((item, iidx) => (
                            <CalendarDateItem
                                item={item}
                                key={iidx}
                                targetDate={targetDate}
                                candidateDates={candidateDates}
                                date={date}
                                setDate={setDate}
                            />
                        ))}
                    </div>
                ))}
            </div>
            <div className="pt-4 max-w-[300px] text-red-500">
                * หากวันเตือนจ่ายที่เลือกคือ 29, 30 หรือ 31 และเดือนนั้นไม่มีวันดังกล่าว
                ระบบจะเตือนในวันสุดท้ายของเดือน
            </div>
        </div>
    )
}

export type { AbsoluteCalendarProps }
